import { useSelector } from 'react-redux';
import { getTableContent } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { ExperimentId } from '../../../../../../common/experiments/experimentsConstants';
import { TableDataVersion } from '../../../../../../common/table/TableTypes';
import { getStoredHotTableDataVersion } from '../../../../../element/table/dataConversion/hotTableDataVersionUtils';
import { useLegacyActiveTableDataVersion } from '../../../../../element/table/store/legacyHotTableStoreHooks';
import { getIsFeatureEnabledForCurrentUser } from '../../../../../element/feature/elementFeatureSelector';

/**
 * Determines whether table tool composition should render the V2 implementation.
 *
 * Prefers the active table runtime version when a table is currently active, otherwise
 * falls back to the persisted table content version and finally the feature flag default.
 */
export const useV2TableComponents = (element: ImMNElement | undefined): boolean => {
    const activeTableDataVersion = useLegacyActiveTableDataVersion();
    const isTableArchV2Enabled = useSelector(getIsFeatureEnabledForCurrentUser(ExperimentId.tableArchV2)) as boolean;

    if (activeTableDataVersion) {
        return activeTableDataVersion === TableDataVersion.V2;
    }

    const storedTableVersion = element ? getStoredHotTableDataVersion(getTableContent(element)) : undefined;

    if (storedTableVersion === TableDataVersion.V2) return true;
    if (storedTableVersion === TableDataVersion.V1) return false;

    return isTableArchV2Enabled;
};
